<app-form-field [label]="title" [control]="formControl"
  required
  [desktopSize]="4"
  [ngClass]="{'is-hidden': isEntitesHidden}">
  @if (multiple) {
    <ejs-multiselect #ejsMultiselect
      [formControl]="formControl"
      [changeOnBlur]="false"
      [allowCustomValue]="isCustomValueAllowed"
      [dataSource]="entites"
      [fields]="{text: 'libelle', value: 'id'}"
      name="entites"
      placeholder="Entités"
      (focus)="setAllowCustomValueToFalse()"
      (change)='emitChange($event)'>
    </ejs-multiselect>
  }

  @if (multiple==false) {
    <select class="select" [formControl]="formControl">
      @for (entite of entites; track entite) {
        <option [ngValue]="entite.id">{{entite.libelle}}</option>
      }
    </select>
  }
</app-form-field>
